import React from 'react';
import Button from '../../shared/components/Form/Button';
import Avatar from '../../shared/components/UIElements/Avatar';

import './SummaryDetails.css';

const SummaryDetails = props => {
     
    return (<div className="summaryDetailsDiv">
         
          <h3>2. Dataset Details</h3>
          <div className="summariesPanelDiv">
          <div className="summaries-description__image">
            <Avatar image={props.dataset.img} alt={props.dataset.title}  width='150px' height='150px' />
          </div>
          <div className="summaries-description__info">
            <h4>{props.dataset.title}</h4>
            <p><b>Entities:</b> {props.dataset.entities} </p>
          </div>
          </div>
          
         <div className="summariesButtonsDiv"><Button onClick={props.recommendationsHandler}>Get Recommendations *</Button></div>
         <p>* It may take several minutes depending on the dataset's size and extent</p>
         </div>);

  };
  
  export default SummaryDetails;